@if (useTemplate() === 'info-box') {
  @if (isStromInfoVisible() || isGasInfoVisible()) {
    <mwe-infobox messageKey="invoiceData.change.newBankData.info" class="d-block mb-3" type="neutral" />
  }

  @if (isGasInfoVisible()) {
    <mwe-infobox class="d-block mb-3" type="neutral">
      <p [innerHTML]="'invoiceData.change.newBankData.infoStromGas' | translate" class="mb-0"></p>
    </mwe-infobox>
  }

  @if (isStromInfoVisible() && !isGasInfoVisible()) {
    <mwe-infobox class="d-block mb-3" type="neutral">
      <p [innerHTML]="'invoiceData.change.newBankData.infoStrom' | translate" class="mb-0"></p>
    </mwe-infobox>
  }

  @if (isFernwaermeInfoVisible()) {
    <mwe-infobox type="neutral">
      <p [innerHTML]="'invoiceData.change.newBankData.infoFernwaerme' | translate" class="mb-0"></p>
    </mwe-infobox>
  }
} @else {
  <mwe-alert type="info">
    <p
      class="text--big text-white"
      [ngClass]="{ 'mb-2': isFernwaermeInfoVisible() || isStromGasInfoVisible() }"
      [innerHTML]="'invoiceData.change.newBankData.info' | translate"
    ></p>
    @if (isStromGasInfoVisible()) {
      <p
        class="text--big text-white"
        [ngClass]="{ 'mb-2': isFernwaermeInfoVisible() }"
        [innerHTML]="'invoiceData.change.newBankData.infoStromGas' | translate"
      ></p>
    }
    @if (isFernwaermeInfoVisible()) {
      <p class="text--big text-white" [innerHTML]="'invoiceData.change.newBankData.infoFernwaerme' | translate"></p>
    }
  </mwe-alert>
}
